
<div class=" bg-secondary text-xs text-white grid grid-cols-4 items-center p-2">
  <div class="col-span-3 flex items-center">
    <ng-content >
    </ng-content>
  </div>
  <div class="col-span-1 justify-end flex self-start content-center items-center paginate-section ">
    <span class="hidden sm:block">
      {{ searchCount }} {{item}}{{ searchCount !== 1 ? 's' : '' }}
    </span>
    <span>
      <i class="bi bi-chevron-left m-1 cursor-pointer" (click)="onPageChange(-1)" [ngClass]="{ 'text-gray-400': currentPage === 1 }"></i>
    </span>
      <input matInput class="number-box" type="number" 
      [(ngModel)]="currentPage" (ngModelChange)="onPageChange(currentPage, true)" min="1" [max]="totalPages"
      [ngClass]="{ 'text-red-800 font-bold': currentPage < 1 || currentPage > totalPages }" />

      <span class="mx-[10px] hidden sm:block">of {{totalPages}}
      </span>
      <i class="bi bi-chevron-right cursor-pointer" (click)="onPageChange(1)" [ngClass]="{ 'text-gray-400': currentPage === totalPages }"></i>
  </div>

</div>